// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"aa37079b","703":"62d34de6","760":"6c17ca60","787":"430eaf58"}[chunkId] + ".chunk.js";
};